export const IconWrite = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.17645 7.23535H5.11763C4.556 7.23535 4.01737 7.45846 3.62024 7.85559C3.22311 8.25273 3 8.79135 3 9.35299V18.8823C3 19.444 3.22311 19.9826 3.62024 20.3797C4.01737 20.7769 4.556 21 5.11763 21H14.647C15.2086 21 15.7472 20.7769 16.1444 20.3797C16.5415 19.9826 16.7646 19.444 16.7646 18.8823V17.8235"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.3486 6.79597C20.7656 6.37896 20.9999 5.81337 20.9999 5.22363C20.9999 4.63389 20.7656 4.0683 20.3486 3.65129C19.9316 3.23427 19.366 3 18.7762 3C18.1865 3 17.6209 3.23427 17.2039 3.65129L8.29395 12.5295V15.7059H11.4704L20.3486 6.79597Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7056 5.11768L18.882 8.29413"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
